<template>
    <div
        class="relative bg-bg-subtle overflow-hidden flex items-center justify-center"
        :class="padClass"
    >
        <!-- Faint list backdrop -->
        <div
            class="absolute inset-x-10 top-8 bottom-0 rounded-t-lg bg-bg-snow border border-border-base opacity-50 hidden sm:block"
            aria-hidden="true"
        >
            <div
                class="grid grid-cols-2 px-4 py-2 border-b border-border-base text-[11px] text-fg-tertiary"
            >
                <span>Merchant</span><span>Card</span>
            </div>
            <div
                v-for="row in previewRows"
                :key="row.name"
                class="grid grid-cols-2 items-center px-4 py-2 border-b border-border-base/50"
            >
                <div class="flex items-center gap-2">
                    <span
                        class="w-6 h-6 rounded-full flex-shrink-0"
                        :class="row.dot"
                    ></span>
                    <div>
                        <div class="text-xs font-medium text-fg-secondary">
                            {{ row.name }}
                        </div>
                        <div class="text-[10px] text-fg-tertiary">
                            {{ row.category }}
                        </div>
                    </div>
                </div>
                <div class="text-[11px] text-fg-tertiary">{{ row.card }}</div>
            </div>
        </div>
        <!-- Floating transaction detail card -->
        <div
            class="relative w-64 rounded-xl bg-bg-snow border border-border-base shadow-lg p-4 text-center"
        >
            <div class="text-[11px] text-fg-tertiary">May 6</div>
            <div
                class="mx-auto my-2 w-12 h-12 rounded-full bg-emerald-700 flex items-center justify-center text-white text-lg font-semibold"
            >
                S
            </div>
            <div class="text-2xl font-semibold text-fg-primary">$42.00</div>
            <div class="text-xs text-fg-tertiary">Starbucks</div>
            <div class="mt-2 text-[11px] text-fg-tertiary">
                Chase Sapphire Preferred® (4821)
            </div>
            <div class="mt-3 rounded-lg border border-border-base p-3 text-left">
                <div class="flex items-center justify-between">
                    <div>
                        <div class="text-xs font-semibold text-fg-primary">
                            126 points
                        </div>
                        <div class="text-[10px] text-fg-tertiary">
                            3x Dining & Restaurants
                        </div>
                    </div>
                    <span class="text-[10px] font-semibold text-fg-tertiary"
                        >CHASE</span
                    >
                </div>
                <div class="mt-2 rounded-md bg-orange-50 p-2">
                    <div class="text-[10px] font-semibold text-10x-orange">
                        42 points missed
                    </div>
                    <div class="text-[10px] text-fg-tertiary">
                        Use Amex Gold Card for 4x Dining & Restaurants
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
defineProps({
    // Outer padding / min-height (override per context).
    padClass: {
        type: String,
        default: 'px-6 pt-10 pb-8 min-h-[260px]',
    },
});

const previewRows = [
    { name: 'AG1 Fitness', category: 'Health & Fitness', card: 'Amex', dot: 'bg-slate-800' },
    { name: 'Whole Foods', category: 'Groceries', card: 'Amex', dot: 'bg-emerald-700' },
    { name: 'Olive Garden', category: 'Restaurants', card: 'Chase', dot: 'bg-rose-700' },
];
</script>
